import React from 'react';
import { useTranslation } from 'react-i18next';
import { Label, SemanticCOLORS, Table } from 'semantic-ui-react';

import { bem } from '../../core/design/bem';
import { Invited } from '../types';

const css = bem('InvitedList');
const translationPrefix = 'group-visits';

type InvitedListProps = {
  invited: Invited[];
};

type StatusInfo = { label: string; color?: SemanticCOLORS };

function getStatusInfo(status: string | undefined, t: (key: string) => string): StatusInfo {
  if (status === 'registered') {
    return { label: t(`${translationPrefix}.invited.status.registered`), color: 'green' };
  }
  if (status === 'refused') {
    return { label: t(`${translationPrefix}.invited.status.refused`), color: 'red' };
  }
  // Pas de statut ou "invited"
  return { label: t(`${translationPrefix}.invited.status.invited`), color: 'grey' };
}

const InvitedList = ({ invited }: InvitedListProps): JSX.Element | null => {
  const { t } = useTranslation();
  if (!invited.length) return null;

  return (
    <Table fixed unstackable className={css().toString()}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>{t(`${translationPrefix}.invited.table.last-name`)}</Table.HeaderCell>
          <Table.HeaderCell>{t(`${translationPrefix}.invited.table.first-name`)}</Table.HeaderCell>
          <Table.HeaderCell>{t(`${translationPrefix}.invited.table.email`)}</Table.HeaderCell>
          <Table.HeaderCell>{t(`${translationPrefix}.invited.table.status`)}</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {invited.map((guest) => {
          const status = getStatusInfo(guest.status, t);
          return (
            <Table.Row key={guest._id}>
              <Table.Cell>{guest.lastName || '—'}</Table.Cell>
              <Table.Cell>{guest.firstName || '—'}</Table.Cell>
              <Table.Cell>{guest.email || '—'}</Table.Cell>
              <Table.Cell>
                <Label size="small" color={status.color}>
                  {status.label}
                </Label>
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

export default InvitedList;
